/**
 * Static comparison matrix: keep Feature + Skiddle columns sticky horizontally.
 * Sets --comparison-feature-w so Skiddle hugs the feature column edge.
 * Also toggles .is-scrolled-end on the fade wrapper when the table is fully scrolled.
 */
export function comparisonTicketingStickyColumns() {
  const table = document.querySelector(".comparison-ticketing-static__matrix");
  if (!table) return;

  const featureHead = table.querySelector(".comparison-tick-sticky-heading");
  const featureBody = table.querySelector("tbody .comparison-tick-sticky-feature");
  const scroll = table.closest(".comparison-ticketing-static__scroll");
  const wrap = table.closest(".comparison-ticketing-static__fade-wrap");

  /** Prefer body column width — primary content width drives layout */
  const measureFeaturePx = () => {
    const w = featureBody
      ? featureBody.getBoundingClientRect().width
      : featureHead
        ? featureHead.getBoundingClientRect().width
        : 0;
    return Math.max(1, Math.round(w));
  };

  const sync = () => {
    table.style.setProperty("--comparison-feature-w", `${measureFeaturePx()}px`);
  };

  sync();
  requestAnimationFrame(() => requestAnimationFrame(sync));

  if (typeof ResizeObserver !== "undefined") {
    const ro = new ResizeObserver(sync);
    if (featureBody) ro.observe(featureBody);
    if (featureHead) ro.observe(featureHead);
  }

  window.addEventListener("resize", sync, { passive: true });

  // Fade: hide the right-edge gradient once the user has scrolled to the end.
  if (scroll && wrap) {
    const updateFade = () => {
      const atEnd = scroll.scrollLeft + scroll.clientWidth >= scroll.scrollWidth - 2;
      wrap.classList.toggle("is-scrolled-end", atEnd);
    };
    updateFade();
    scroll.addEventListener("scroll", updateFade, { passive: true });
    window.addEventListener("resize", updateFade, { passive: true });
  }
}
